<router-outlet></router-outlet>
<ng-http-loader 
  [backgroundColor]="'#FFFFFF'"   
    [opacity]="'0.5'"
    [backdropBackgroundColor]="'#000000'"
    [spinner]="spinkit.skWanderingCubes">
</ng-http-loader>
